import history from './history'
import massApproval from './massApproval'
import table from './table'

export default {
    saveSuccess: 'Vorgang wurde erfolgreich gespeichert.',
    deleteProcess: 'Vorgang löschen',
    deleteProcessNumberText: 'Möchtest du den Vorgang {number} wirklich löschen?',
    deleteProcessText: 'Möchtest du diesen Vorgang wirklich löschen?',
    deleteProcessSuccess: 'Vorgang wurde erfolgreich gelöscht.',
    deleteProcessError: 'Der Vorgang konnte nicht gelöscht werden.',

    process: 'Vorgang',
    processId: 'Vorgang {id}',
    event: 'Veranstaltung',
    subsidy: 'Zuschuss',
    formProcess: 'Formular',
    formProcesses: 'Formulare',
    formProcessesCount: 'Keine Formulare|{count} Formular|{count} Formulare',
    noDocumentCouldBeExported: 'Es konnte kein Dokument zur Ansicht gefunden oder erzeugt werden.',
    exportError: 'Fehlende Vorlagen',
    additional: 'Weitere Informationen',

    confirmLeave: 'Du hast nicht gespeicherte Änderungen in diesem Vorgang. Möchtest du die Seite wirklich verlassen?',

    requester: 'Antragsteller',
    requestOf: 'Beantragt von',
    requestFor: 'für Förderprogramm',
    creatorUser: 'Ansprechperson',
    callOrganisation: 'Organisation aufrufen',
    mailCreatorUser: 'E-Mail an Ansprechperson',
    bankAccount: 'Bankverbindung',
    noOrganisation: 'Kein Antragsteller',
    noCreatorUser: 'Keine Ansprechperson',
    noBankAccount: 'Keine Bankverbindung',
    viewProcessesOfEvent: 'Vorgänge der Veranstaltung anzeigen',

    organisation_id: 'Organisations-ID',
    creator_user_id: 'Ersteller*in-ID',
    event_id: 'Veranstaltungs-ID',
    year_id: 'Jahres-ID',
    serial_number: 'Lfd. Nummer',
    process_number: 'Vorgangsnummer',
    funding_program_id: 'Förderprogramm-ID',
    bank_account_id: 'Bankverbindungs-ID',

    startDate: 'Startdatum',
    start_date: 'Startdatum',
    endDate: 'Enddatum',
    end_date: 'Enddatum',
    location: 'Ort',
    title: 'Bezeichnung',
    daysTotal: 'Tage',
    totalDays: 'Tage',
    daysEligible: 'Anrechenbare Tage',
    eligibleDays: 'Anrechenbare Tage',
    eligible_days: 'Anrechenbare Tage',
    eligibleHours: 'Lehrgangsstunden',
    eligible_hours: 'Lehrgangsstunden',
    eligibleHoursRate: 'Faktor Lehrg.',
    cateredDays: 'Verpflegungstage',
    catered_days: 'Verpflegungstage',
    subsidyRate: 'Faktor Zuschuss',
    persons: 'Personen',
    eligible: 'Anrechenbar',
    personsTotal: 'Personen',
    persons_total: 'Personen',
    personsMale: 'Personen männlich',
    persons_male: 'Personen männlich',
    personsFemale: 'Personen weiblich',
    persons_female: 'Personen weiblich',
    personsOther: 'Personen divers',
    persons_other: 'Personen divers',
    eligiblePersons: 'Anrechenbare Personen',
    eligibleTotal: 'Anrechenbar',
    eligibleMale: 'Anrechenbare männlich',
    eligibleFemale: 'Anrechenbare weiblich',
    eligibleOther: 'Anrechenbare divers',
    eligiblePersonsTotal: 'Anrechenbare Personen',
    eligible_persons_total: 'Anrechenbare Personen',
    eligiblePersonsMale: 'Anrechenbare männlich',
    eligible_persons_male: 'Anrechenbare Personen männlich',
    eligiblePersonsFemale: 'Anrechenbare weiblich',
    eligible_persons_female: 'Anrechenbare Personen weiblich',
    eligiblePersonsOther: 'Anrechenbare divers',
    eligible_persons_other: 'Anrechenbare Personen divers',

    totalCost: 'Gesamtkosten',
    total_cost: 'Gesamtkosten',
    subsidyRequested: 'Beantragt',
    subsidy_requested: 'Beantragt',
    subsidyGranted: 'Bewilligt',
    subsidy_granted: 'Bewilligt',
    subsidyGrantedAt: 'Bewilligt am',
    subsidy_granted_at: 'Bewilligt am',
    subsidyDue: 'Zustehend',
    subsidy_due: 'Zustehend',
    subsidyReceivedTooMuch: 'Zuviel erstattet',
    subsidy_received_too_much: 'Zuviel erstattet',
    subsidy_open_payment: 'Offene Zahlungen',

    fileReferenceNumber: 'Aktenzeichen',
    file_reference_number: 'Aktenzeichen',
    cashReferenceNumber: 'Kassenzeichen',
    cash_reference_number: 'Kassenzeichen',
    internalReferenceNumber: 'Interne Bearbeitungsnummer',
    internal_reference_number: 'Interne Bearbeitungsnummer',
    comment: 'Anmerkungen',
    editorialComment: 'Änderungsbemerkungen',
    editorial_comment: 'Änderungsbemerkungen',
    internalComment: 'Interne Bemerkungen',
    internal_comment: 'Interne Bemerkungen',
    commentTooltip: 'Sieht Antragsteller und RP auf Zusatzliste',
    editorialCommentTooltip: 'Sieht nur Antragsteller',
    internalCommentTooltip: 'Nur für Verband',

    cancellationComment: 'Stornobemerkung',
    cancellation_comment: 'Stornobemerkung',
    editCancellationComment: 'Stornobemerkung bearbeiten',
    editCancellationCommentHelpText: 'Die Stornobemerkung wird nur gespeichert, wenn der Vorgang gespeichert wird.',
    setCancellationComment: 'Stornobemerkung setzen',

    menu: {
        processBaseData: 'Grunddaten',
        processActivities: 'Historie'
    },

    copy: {
        slideOverTitle: 'Vorgang kopieren',
        slideOverDescription: 'Hier kannst du einstellen, wie der Vorgang kopiert werden soll.',
        copyWithNewEvent: 'Neue Veranstaltung erstellen',
        copyWithNewEventDescription: 'Erstellt den kopierten Vorgang in einer neuen Veranstaltung. Der Zeitraum wird in das gewählte Jahr übertragen und kann später angepasst werden.<br>' +
            'Kann nur ausgeschaltet werden, wenn die im Vorgang verwendeten Formulare mehrfach in einer Veranstaltung angelegt werden können und wenn innerhalb eines Jahres kopiert wird.',
        eventName: 'Veranstaltungsname',
        copyExecutedProgram: 'Programmnachweis kopieren',
        copyExecutedProgramDescription: 'Soll das Programm mitkopiert werden?',
        copyCostsAndSubsidy: 'Kosten und Zuschüsse kopieren',
        copyCostsAndSubsidyDescription: 'Sollen die Kosten und Zuschüsse mitkopiert werden?',
        copyDocuments: 'Dokumente kopieren',
        copyDocumentsDescription: 'Sollen die Dokumente mitkopiert werden?',
        copyPersons: 'Personen kopieren',
        copyPersonsDescription: 'Sollen die Personen mitkopiert werden?',
        copyProcess: 'Vorgang kopieren',
        copyProcessSuccess: 'Vorgang wurde erfolgreich kopiert.',
    },

    addDocuments: {
        slideOverTitle: 'Dokumente hinzufügen',
        slideOverDescription: 'Hier kannst du Dokumente zu diesem Vorgang hinzufügen.',
        addDocuments: 'Dokumente hinzufügen',
        addDocumentsSuccess: 'Dokumente wurden erfolgreich hinzugefügt.',
    },

    documents: {
        deleteDocument: 'Dokument löschen',
        deleteDocumentText: 'Möchtest du dieses Dokument wirklich löschen?',
        deleteSuccess: 'Das Dokument wurde erfolgreich gelöscht.',
        deleteError: 'Das Dokument konnte nicht gelöscht werden.',

        attached: 'Hinzugefügt',
        detached: 'Entfernt',

        move: {
            action: 'In ein Formular verschieben',
            title: 'Dokument in ein Formular verschieben',
            description: 'Wähle aus, in welchen Antrag und in welche Upload-Box "{fileName}" verschoben werden soll.',
            formProcess: 'Antrag',
            uploadBox: 'Upload-Box',
            noTargets: 'Für diesen Vorgang steht kein Antrag mit passenden Upload-Boxen zur Verfügung.',
            submit: 'Verschieben',
            success: 'Das Dokument wurde verschoben.',
            failure: 'Das Dokument konnte nicht verschoben werden.',
            loadTargetsFailure: 'Die Ziele konnten nicht geladen werden.',
        },
    },

    tools: {
        tools: 'Werkzeuge',
        resetSlNumber: 'SL-Nummer zurücksetzen',
        resetSlNumberDescription: 'Hier kannst du die SL-Nummer zurücksetzen.',
        reallyResetSlNumber: 'Möchtest du die SL-Nummer wirklich zurücksetzen?',
        slNumberResetSuccess: 'SL-Nummer wurde erfolgreich zurückgesetzt',
        errorOnResettingSlNumber: 'SL-Nummer konnte nicht zurückgesetzt werden',
    },

    table,
    massApproval,
    history
}